

import { Rocket, Target, Globe, Cpu, Zap, Building2, Layers, Star, Play } from "lucide-react";

export const TrustLogos = () => {
  const companies = [
    { name: "Ship2myid", icon: <Rocket className="w-5 h-5" /> },
    { name: "Green Future", icon: <Target className="w-5 h-5" /> }, 
    { name: "Tao Digital", icon: <Globe className="w-5 h-5" /> },
    { name: "Nemera Tech", icon: <Cpu className="w-5 h-5" /> },
    { name: "Airoi", icon: <Zap className="w-5 h-5" /> },
    { name: "Global IT", icon: <Building2 className="w-5 h-5" /> },
    { name: "CloudEQS", icon: <Layers className="w-5 h-5" /> }, 
    { name: "Nebula Systems", icon: <Star className="w-5 h-5" /> },
    { name: "Vortex Media", icon: <Play className="w-5 h-5" /> }
  ];

  return (
    <section className="py-24 bg-white border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-xs font-black text-slate-400 uppercase tracking-[0.3em] mb-16">
          Propelling the world's most ambitious teams
        </p>
      </div>
      
      <div className="relative flex overflow-x-hidden">
        <div className="flex animate-[marquee_40s_linear_infinite] whitespace-nowrap gap-16 items-center hover:[animation-play-state:paused]">
          {[...companies, ...companies].map((company, i) => (
            <div 
              key={i} 
              className="flex items-center gap-3 grayscale opacity-30 hover:opacity-100 hover:grayscale-0 transition-all duration-500 cursor-default group"
            >
              <div className="p-2 rounded-lg bg-slate-50 group-hover:bg-brand-accent/10 text-slate-400 group-hover:text-brand-accent transition-colors">
                {company.icon}
              </div>
              <span className="text-xl font-display font-bold text-slate-600 group-hover:text-brand-primary tracking-tight">
                {company.name}
              </span>
            </div>
          ))}
        </div>

        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />
      </div>
    </section>
  );
};
